module.exports = __webpack_public_path__ + "img/about_logo_19.cf8eba71.png";